import {BackgroundVideo} from 'epic-react-common';
import epicTracking from 'epic-tracking';
import React from 'react';
import VisibilitySensor from 'react-visibility-sensor';

import AnimateString from '../../common/AnimateString';
import {FeatureVideo} from '../FeatureHeroCarousel/Types';
import VBucksFeature from '../VBucksFeature/VBucksFeature';

import {
  VBucksContent,
  VBucksContentContainer,
  VBucksImage,
  VBucksSectionContainer,
} from './components';

interface CmsData {
  bgImage: string;
  vBuckImg: string;
  title: string;
  description: string;
  vBuckImgMobile: string;
  vBucksImageAlt: string;
  customLayout: boolean;
  calloutDescription: string;
  calloutTitle: string;
  background: FeatureVideo;
}
interface Props {
  mobile: boolean;
  tablet: boolean;
  data: CmsData;
}

const VBucksSection = ({data, mobile, tablet}: Props) => {
  const {vBuckImg, title, description, vBuckImgMobile, vBucksImageAlt, customLayout, background} =
    data;
  const mainImage = (mobile || tablet) && vBuckImgMobile ? vBuckImgMobile : vBuckImg;
  const [visible, setVisibility] = React.useState(false);

  const setSectionVisibility = React.useCallback(
    (visibility) => {
      setVisibility(visibility);
      if (visibility) {
        epicTracking.trackEvent('Interaction', {
          interactionType: 'scrollViewSection',
          eventCategory: 'BattlePass VBucks Section',
          eventAction: 'VBucksSection-inView',
        });
      }
    },
    [setVisibility]
  );

  if (customLayout) return <VBucksFeature data={data} mobile={mobile} />;

  return (
    <VisibilitySensor
      active={!visible}
      onChange={setSectionVisibility}
      partialVisibility
      minTopValue={0}>
      <VBucksSectionContainer>
        {background && <BackgroundVideo background={background} mobile={mobile} tablet={tablet} />}
        <VBucksContentContainer>
          <VBucksContent>
            {title ? (
              <AnimateString
                key="VBucksSection-h2"
                text={title}
                type="h2"
                speed={1.5}
                delay={0}
                autoAlpha={0}
                yPos={100}
                minTop={20}
                scaleFrom={1}
                staggerDelay={0}
              />
            ) : null}
            {description ? (
              <AnimateString
                key="VBucksSection-p"
                text={description}
                type="p"
                speed={1.5}
                delay={0.2}
                autoAlpha={0}
                yPos={100}
                minTop={20}
                scaleFrom={1}
                staggerDelay={0}
              />
            ) : null}
          </VBucksContent>
          {mainImage && <VBucksImage src={mainImage} alt={vBucksImageAlt} />}
        </VBucksContentContainer>
      </VBucksSectionContainer>
    </VisibilitySensor>
  );
};

export default VBucksSection;
